<template>
  <div class="" testek="product-detail">
    <div class="header"></div>
    <BaseDetail
      @viewDetail="viewDetail"
      @addData="addData"
      @addMoreData="addMoreData"
      :currentItem="currentItem"
      :titleDetail="$t('i18nCommon.TitleOrderId')"
    >
      <template #header>
        <div class="font-bold text-xl mb-4">
          {{ title }}
        </div>
      </template>
      <template #content>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              class="demo-ruleForm"
              status-icon
            >
              <a-form-item
                prop="Id"
                testek="Id"
                class="columns-1 w-full"
                v-if="mode == $enum.Mode.Edit"
              >
                <div class="flex">
                  <div class="font-bold min-w-40">
                    ID
                    <span class="ml-1 text-red-700">*</span>
                  </div>
                  <a-input v-model:value="ruleForm.id" />
                </div>
              </a-form-item>
              <div class="flex columns-2">
                <a-form-item
                  prop="customerId"
                  testek="customer"
                  class="w-full mr-8"
                >
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Customer") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-select
                      v-model:value="ruleForm.customerId"
                      show-search
                      :placeholder="$t('i18nProduct.Customer')"
                      testek="customer-combobox"
                      :filterOption="false"
                      :options="customerFilters"
                      @focus="loadDataCustomer"
                      @change="onChangeCustomer"
                      @search="filterDataCustomer"
                      class="w-full"
                      :popupClassName="'dropdown-menu-customer'"
                      :field-names="{
                        label: `name`,
                        value: `id`,
                      }"
                    >
                      <template #option="{ isTitle, name, address }">
                        <tr
                          :class="isTitle ? 'font-bold select-title' : ''"
                          :disabled="isTitle"
                          @click="isTitle ? $event.stopPropagation() : null"
                        >
                          <td class="td-item td-item-customer">
                            {{ name }}
                          </td>
                          <td class="td-item td-item-customer">
                            {{ address }}
                          </td>
                        </tr>
                      </template>
                    </a-select>
                  </div>
                </a-form-item>
                <a-form-item prop="phoneNum" testek="phone" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.phoneNum" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item
                  prop="shippingPhoneNum"
                  testek="shipPhone"
                  class="w-full mr-8"
                >
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.ShipPhone") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.shippingPhoneNum" />
                  </div>
                </a-form-item>
                <a-form-item prop="email" testek="email" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      Email
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.email" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item
                  prop="shipAddress"
                  testek="shipAddress"
                  class="w-full"
                >
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.ShipAddress") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.shippingAddress" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item
                  testek="Same with shipping address"
                  class="w-full mr-8"
                >
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.InvoiceAddress") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-checkbox
                      class="ml-1"
                      v-model:checked="ruleForm.sameAddress"
                      @change="changeSameAddress"
                    />
                    <div class="ml-1">
                      {{ $t("i18nProduct.SameWithShippingAddress") }}
                    </div>
                  </div>
                </a-form-item>
                <a-form-item prop="employeeId" testek="employee" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Employee") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-select
                      v-model:value="ruleForm.employeeId"
                      show-search
                      :placeholder="$t('i18nProduct.Employee')"
                      testek="employee-combobox"
                      :filterOption="false"
                      :options="employeeFilters"
                      @focus="loadDataEmployee"
                      @change="onChangeEmployee"
                      @search="filterDataEmployee"
                      class="w-full"
                      :popupClassName="'dropdown-menu-employee'"
                      :field-names="{
                        label: `empFullName`,
                        value: `id`,
                      }"
                    >
                      <template #option="{ isTitle, empFullName, empCode }">
                        <tr
                          :class="isTitle ? 'font-bold select-title' : ''"
                          :disabled="isTitle"
                          @click="isTitle ? $event.stopPropagation() : null"
                        >
                          <td class="td-item td-item-employee">
                            {{ empFullName }}
                          </td>
                          <td class="td-item td-item-employee">
                            {{ empCode }}
                          </td>
                        </tr>
                      </template>
                    </a-select>
                  </div>
                </a-form-item>
              </div>
              <div class="columns-1">
                <a-form-item
                  prop="invoiceAddress"
                  testek="invoiceAddress"
                  class="w-full"
                >
                  <div class="flex">
                    <a-input v-model:value="ruleForm.invoiceAddress" />
                  </div>
                </a-form-item>
              </div>
              <a-form-item class="mt-6">
                <div class="flex">
                  <a-button
                    type="primary"
                    testek="btn-add"
                    @click="submitForm()"
                    class="mr-4"
                  >
                    {{ $t("i18nCommon.Add") }}
                  </a-button>
                  <a-button
                    type="primary"
                    testek="btn-add-more"
                    @click="addMoreData()"
                  >
                    {{ $t("i18nCommon.AddMore") }}
                  </a-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </template>
    </BaseDetail>
    <div v-if="isShow && order">
      <a-modal v-model:open="isShow" centered :width="800" :closable="false">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.Order") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
            >
              <div class="flex columns-2">
                <a-form-item
                  prop="customer"
                  testek="customer"
                  class="w-full mr-8"
                >
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Customer") }}
                    </div>
                    <a-input
                      v-model:value="order.customerId.id"
                      :disabled="true"
                    />
                  </div>
                </a-form-item>
                <a-form-item prop="phone" testek="phone" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                    </div>
                    <a-input
                      v-model:value="order.shippingPhoneNum"
                      :disabled="true"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item
                  prop="shipPhone"
                  testek="shipPhone"
                  class="w-full mr-8"
                >
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.ShipPhone") }}
                    </div>
                    <a-input
                      v-model:value="order.shippingPhoneNum"
                      :disabled="true"
                    />
                  </div>
                </a-form-item>
                <a-form-item prop="email" testek="email" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">Email</div>
                    <a-input
                      v-model:value="order.customerId.email"
                      :disabled="true"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item
                  prop="shipAddress"
                  testek="shipAddress"
                  class="w-full"
                >
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.ShipAddress") }}
                    </div>
                    <a-input
                      v-model:value="order.shippingAddress"
                      :disabled="true"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="employee" testek="employee" class="w-full">
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.Employee") }}
                    </div>
                    <a-input
                      v-model:value="order.employeeId"
                      :disabled="true"
                    />
                  </div>
                </a-form-item>
              </div>
              <div class="columns-1">
                <a-form-item
                  prop="invoiceAddress"
                  testek="invoiceAddress"
                  class="w-full"
                >
                  <div class="flex">
                    <div class="flex min-w-40 font-bold">
                      {{ $t("i18nProduct.InvoiceAddress") }}
                    </div>
                    <a-input
                      v-model:value="order.invoiceAddress"
                      :disabled="true"
                    />
                  </div>
                </a-form-item>
              </div>
              <a-form-item v-if="order.orderItems && order.orderItems.length">
                <div>
                  <div class="table-items">
                    <a-table
                      bordered
                      :data-source="order.orderItems"
                      :columns="columnViews"
                      :pagination="false"
                      :scroll="{ y: '250px' }"
                    >
                      <template #bodyCell="{ column, record }">
                        <template v-if="column.key === 'name'">
                          <div class="name-text">
                            {{ record[`${column.dataIndex}`] }}
                          </div>
                        </template>
                        <template
                          v-if="
                            record &&
                            column.keyIndex === 'supplierObject' &&
                            record.supplier
                          "
                        >
                          <div class="name-text">
                            {{ record.supplier[`${column.dataIndex}`] }}
                          </div>
                        </template>
                        <template
                          v-if="
                            record &&
                            column.keyIndex === 'productObject' &&
                            record.product
                          "
                        >
                          <div class="name-text">
                            {{ record.product[`${column.dataIndex}`] }}
                          </div>
                        </template>
                        <template
                          v-if="
                            record &&
                            column.keyIndex === 'categoryObject' &&
                            record.category
                          "
                        >
                          <div class="name-text">
                            {{ record.category[`${column.dataIndex}`] }}
                          </div>
                        </template>
                        <template
                          v-if="
                            record &&
                            column.dataIndex === 'status' &&
                            record.status
                          "
                        >
                          <span>
                            <a-tag
                              :color="
                                record &&
                                record.status &&
                                (record.status.toUpperCase() === 'INACTIVE' ||
                                  record.status.toUpperCase() === 'CANCELLED')
                                  ? 'volcano'
                                  : 'green'
                              "
                            >
                              {{ record.status.toUpperCase() }}
                            </a-tag>
                          </span>
                        </template>
                      </template>
                    </a-table>
                  </div>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import {
  ModuleCustomer,
  ModuleEmployee,
  ModuleOrder,
} from "@/store/module-const";
import BaseDetail from "@/views/base/BaseDetail.vue";
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
export default {
  name: "OrderDetail",
  components: {
    BaseDetail,
  },
  props: {},
  data() {
    return {
      ruleForm: {},
      rules: {},
      contacts: [],
      employees: [],
      currentItem: {},
      order: {},
      isShow: false,
      mode: this.$enum.Mode.Add,
      columnViews: [],
    };
  },
  created() {
    const me = this;
    me.initDataStatic();
    me.$emitter.on("LoadEditOrder", me.loadDataEdit);
  },
  computed: {
    ...mapGetters(ModuleCustomer, ["Customers"]),
    ...mapGetters(ModuleEmployee, ["Employees"]),
    title() {
      if (this.mode == this.$enum.Mode.Edit)
        return this.$t("i18nCommon.EditOrder");
      return this.$t("i18nCommon.AddOrder");
    },
    sameAddresOrder() {
      const me = this;
      return (
        me.order &&
        me.order.shippingAddress &&
        me.order.invoiceAddress &&
        me.order.shippingAddress == me.order.invoiceAddress
      );
    },
    customerFilters() {
      const me = this;
      let firstData = {
        name: me.$t("i18nCommon.CustomerInfo.Name"),
        address: me.$t("i18nCommon.CustomerInfo.Address"),
        isTitle: true,
      };

      if (!me.Customers || me.Customers.length <= 0) {
        return [firstData];
      }

      let customers = [firstData, ...me.Customers];
      return customers;
    },

    employeeFilters() {
      const me = this;
      let firstData = {
        empFullName: me.$t("i18nCommon.EmployeeInfo.Name"),
        empCode: me.$t("i18nCommon.EmployeeInfo.Code"),
        isTitle: true,
      };

      if (!me.Employees || me.Employees.length <= 0) {
        return [firstData];
      }

      let employees = [firstData, ...me.Employees];
      return employees;
    },
  },
  beforeDestroy() {
    const me = this;
    me.$emitter.off("LoadEditOrder", me.loadDataEdit);
  },
  methods: {
    ...mapActions(ModuleCustomer, ["getCustomerList"]),
    ...mapActions(ModuleEmployee, ["getEmployeeList"]),
    ...mapActions(ModuleOrder, ["createOrder", "getOrder", "updateOrder"]),
    initDataStatic() {
      const me = this;
      me.rules = {
        customerId: [
          {
            required: true,
            message: `${me.$t("i18nProduct.CustomerInvalid")}`,
            trigger: ["change", "blur"],
          },
        ],
        shippingPhoneNum: [
          {
            required: true,
            message: `${me.$t("i18nProduct.ShippingPhoneInvalid")}`,
            trigger: "blur",
          },
        ],

        customerId: [
          {
            required: true,
            message: `${me.$t("i18nProduct.CustomerInvalid")}`,
            trigger: ["change", "blur"],
          },
        ],
        shippingAddress: [
          {
            required: true,
            message: `${me.$t("i18nProduct.AddressInvalid")}`,
            trigger: "blur",
          },
        ],
        invoiceAddress: [
          {
            required: true,
            message: `${me.$t("i18nProduct.AddressInvalid")}`,
            trigger: ["change", "blur"],
          },
        ],
        quantity: [
          {
            required: true,
            message: `${me.$t("i18nProduct.QuantityInvalid")}`,
            trigger: "blur",
          },
        ],
        phoneNum: [
          {
            required: true,
            message: `${me.$t("i18nProduct.PhoneNumberInvalid")}`,
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: `${me.$t("i18nProduct.EmailInvalid")}`,
            trigger: "blur",
          },
        ],
        employeeId: [
          {
            required: true,
            message: `${me.$t("i18nProduct.EmployeeInvalid")}`,
            trigger: ["change", "blur"],
          },
        ],
      };

      me.columnViews = [
        {
          title: me.$t("i18nCommon.Product"),
          dataIndex: "productName",
          keyIndex: "productObject",
        },
        {
          title: me.$t("i18nCommon.Quantity"),
          dataIndex: "quantity",
          width: "25%",
        },
        {
          title: me.$t("i18nCommon.Price"),
          dataIndex: "price",
          keyIndex: "productObject",
        },
        {
          title: me.$t("i18nCommon.DiscountRate"),
          dataIndex: "discountRate",
          keyIndex: "productObject",
        },
        {
          title: me.$t("i18nProduct.Status"),
          dataIndex: "status",
          width: 150,
          align: "center",
        },
      ];
    },

    loadDataEdit: _.debounce(async function (payload) {
      const me = this;
      if (!payload) return;
      me.mode = payload.mode;

      //load khách hàng
      await me.loadDataCustomer();

      //load nhân viên
      await me.loadDataEmployee();

      setTimeout(async () => {
        let order = await me.getOrder({ id: payload.id });
        if (order) {
          me.ruleForm = {
            id: order.id,
            customerId: order.customerId ? order.customerId.id : null,
            status: order.status,
            shippingAddress: order.shippingAddress,
            shippingPhoneNum: order.shippingPhoneNum,
            invoiceAddress: order.invoiceAddress,
            quantity: order.quantity,
            amount: order.amount,
            phoneNum: order.customerId ? order.customerId.phoneNum : null,
            email: order.customerId ? order.customerId.email : null,
          };
          me.ruleForm.sameAddress =
            me.ruleForm.shippingAddress === me.ruleForm.invoiceAddress;
        }
      }, 300);
    }, 300),
    async submitForm(isReset = true) {
      const me = this;
      let formEl = me.$refs.ruleFormRef;
      if (!formEl) return;

      formEl
        .validate()
        .then(async () => {
          if (me.mode == me.$enum.Mode.Edit) {
            await me.editData();
          } else {
            await me.addData(isReset);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    onChangeCustomer(payload) {
      const me = this;
    },

    onChangeEmployee(payload) {
      const me = this;
      let employee = me.Employees.find((x) => x.id == payload);
      if (employee) {
        me.ruleForm.employeeId = employee.id;
      }
    },

    loadDataCustomer: _.debounce(async function () {
      const me = this;
      if (me.Customers && me.Customers.length > 0) return;
      await me.getCustomerList();
    }, 300),

    filterDataCustomer: _.debounce(async function (searchText) {
      const me = this;
      await me.getCustomerList({
        keyword: searchText,
      });
    }, 300),

    loadDataEmployee: _.debounce(async function () {
      const me = this;
      if (me.Employees && me.Employees.length > 0) return;
      await me.getEmployeeList();
    }, 300),

    filterDataEmployee: _.debounce(async function (searchText) {
      const me = this;
      await me.getEmployeeList({
        keyword: searchText,
      });
    }, 300),

    addMoreData: _.debounce(async function () {
      const me = this;
      await me.submitForm(false);
    }, 300),
    addData: _.debounce(async function (isReset = true) {
      const me = this;
      let result = await me.createOrder(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddOrderSuccess")
        );
        if (isReset == true) {
          me.ruleForm = {};
        }
      } else if (
        result &&
        (result.statusCode == 400 || result.statusCode == 409)
      ) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          result.message,
          "warning"
        );
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddOrderFail"),
          "warning"
        );
      }
    }, 300),

    editData: _.debounce(async function () {
      const me = this;
      let result = await me.updateOrder(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditOrderSuccess")
        );
        me.ruleForm = {};
      } else if (
        result &&
        (result.statusCode == 400 || result.statusCode == 409)
      ) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          result.message,
          "warning"
        );
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditOrderFail"),
          "warning"
        );
      }
    }, 300),
    viewDetail: _.debounce(async function (params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.order = await me.getOrder({ id: params.id });
      if (me.order) {
        me.isShow = true;
      } else {
      }
      //Show form chi tiết
    }, 300),

    changeSameAddress(e) {
      const me = this;
      let checked = e && e.target && e.target.checked;
      if (checked) {
        me.ruleForm.invoiceAddress = me.ruleForm.shippingAddress;
      } else {
        me.ruleForm.invoiceAddress = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
